// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import { router } from './router'
import store from './store';
import './utils/filters';// 导入全局过滤器
import './utils/directives'; // 导入全局指令

// import echarts from 'echarts';
Vue.config.productionTip = false

// 安装elementui插件
Vue.use(ElementUI, { size: 'small' })

// 全局安装element-ui v-loading指令
Vue.use(ElementUI.Loading.directive)

// vue原型链挂载elementui常用消息框
Vue.prototype.$loading = ElementUI.Loading.service;
Vue.prototype.$msgbox = ElementUI.MessageBox;
Vue.prototype.$alert = ElementUI.MessageBox.alert;
Vue.prototype.$confirm = ElementUI.MessageBox.confirm;
Vue.prototype.$prompt = ElementUI.MessageBox.prompt;
Vue.prototype.$notify = ElementUI.Notification;
Vue.prototype.$message = ElementUI.Message;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  mounted () {
  },
  components: { App },
  template: '<App/>'
})

// 分页
import Pagination from '@/views/components/Pagination.vue'
Vue.component('Pagination', Pagination)


// WEBPACK FOOTER //
// ./src/main.js